<template>
  <v-dialog
    v-if="show"
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card v-touch="{ right: () => $emit('close') }">
      <v-toolbar>
        <v-btn icon @click="$emit('close')">
          <v-icon>arrow_back_ios</v-icon>
        </v-btn>
        <v-toolbar-title>Reklamation</v-toolbar-title>
      </v-toolbar>
      <v-subheader class="text-h5">
        Följesedel / leveransreklamation
      </v-subheader>
      <v-card-text>
        <p>
          På den här sidan kan du se din följesedel. Om levererat antal skiljer sig mot antalet du fått kan du göra en leveransreklamation. Öppna upp aktuell dag och klicka på punkterna till höger. Skriv in levererat antal i Mottagit-rutan och klicka på SPARA. Det nya levererade antalet syns nu på sidan så att du lätt kan se att en reklamation är gjord. Behöver du ändra igen klickar du på siffran och skriver in det rätta antalet och klickar på SPARA.
        </p>
        <p>
          Leveransreklamationen ska göras på leveransdagen, eller snarast möjligt. Följesedeln finns kvar på sidan i en vecka.
        </p>        
        <v-btn block class="mt-6" @click="$emit('close')">
          Ok
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from '@/components/web/dialogs/DialogMixin'

export default {
  name: 'DeliveryInfoDialog',
  mixins: [DialogMixin],
  data() {
    return {    
    }
  }
}
</script>
